import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as utils from '../../../utils/utilities';

class MTDrawingSheetForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		drawing: Joi.array().min(1).required().label('Drawing'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data.drawing);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: 1,
					multiple: false,
					name: 'drawing',
					accept: 'image/*,application/pdf',
					label: 'Drawing',
					sublabel: 'Upload drawing image',
					types: utils.getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

const initialData = { drawing: [] };

export default MTDrawingSheetForm;
